import { QuillModules } from 'ngx-quill';

export const QUILL_MODULES_TEXTAREA: QuillModules = {
  toolbar: [
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline'],
    ['link'],
    [{ list: 'ordered' }, { list: 'bullet' }],
  ],
};

